import { AutopaymentIcon } from '@/components/icons/AutopaymentIcon'
import { LocationIcon } from '@/components/icons/LocationIcon'
import { ServicesIcon } from '@/components/icons/ServicesIcon'
import { WalletIcon } from '@/components/icons/WalletIcon'

export const STATS_CARDS = [
  {
    icon: <WalletIcon className="text-white" size="32px" />,
    title: 'stats.services.title',
    textColor: 'text-white',
    bgColor: 'bg-primary-600'
  },
  {
    icon: (
      <LocationIcon className="text-primary-600" size="32px" height="32px" />
    ),
    title: 'stats.branches.title',
    textColor: 'text-primary-600',
    bgColor: 'bg-secondary-500'
  },
  {
    icon: <AutopaymentIcon className="text-primary-600" size="32px" />,
    title: 'stats.payments.title',
    textColor: 'text-primary-600',
    bgColor: 'bg-tertiary-500'
  },
  {
    icon: <ServicesIcon className="text-primary-600" size="32px" />,
    title: 'stats.grouped.title',
    textColor: 'text-primary-600',
    bgColor: 'bg-positive-500'
  }
]
